import { define } from './define';

// Results: what each network reports about the posts the app published. Keys start with "results.".
export const results = define({
  es: {
    'results.title': 'Resultados',
    'results.defaultRange': 'Últimos 90 días',
    'results.filters': 'Filtros',
    'results.network': 'Red',
    'results.allNetworks': 'Todas las redes',
    'results.from': 'Desde',
    'results.to': 'Hasta',
    'results.clear': 'Quitar filtros',
    'results.note': 'Cada red cuenta a su manera, así que nunca se suman entre sí: una «visualización» no significa lo mismo en todas. Los totales de cada red salen de la última lectura de cada publicación.',
    'results.empty': 'Sin resultados en estas fechas.',
    'results.emptyHint': 'Las lecturas se toman 1 hora, 1 día, 7 días y 28 días después de que la app publique (las stories antes, porque sus números desaparecen al día). Lo que se publica a mano no tiene lecturas.',

    'results.posts': { one: '{count} publicación', other: '{count} publicaciones' },
    'results.read': { zero: 'ninguna leída todavía', one: '{count} con lectura', other: '{count} con lectura' },
    'results.totals': 'Totales de {network}',
    'results.col.post': 'Publicación',
    'results.col.reading': 'Lectura',
    'results.col.after': 'Tras',
    'results.col.state': 'Estado',
    'results.metric.views': 'Visualizaciones',
    'results.metric.reach': 'Alcance',
    'results.metric.likes': 'Me gusta',
    'results.metric.comments': 'Comentarios',
    'results.metric.shares': 'Compartidos',
    'results.metric.saves': 'Guardados',
    'results.metric.avgWatchSeconds': 'Visionado medio',
    'results.metric.watchMinutes': 'Tiempo visto (min)',
    'results.seconds': '{n} s',
    'results.after': 'Tras {age}',
    'results.notRead': 'Sin leer todavía',
    'results.readings': 'Lecturas',
    'results.readingsOf': 'Lecturas de {title}',
    'results.readingTitle': '{age}: {status}',
    'results.private': 'Privada: son números de una publicación que solo ve la cuenta',
    'results.published': 'Publicada el {date}',
    'results.openPost': 'Abrir la publicación',
    'results.readAt': 'Leída el {date}',
    'results.dueAt': 'Toca el {date}',
    'results.detailNote': 'Cada red cuenta a su manera, y algunas no dan ciertos números para algunos tipos de publicación. Una raya significa que la red no dio ese número.',

    'results.age.1h': '1 hora',
    'results.age.6h': '6 horas',
    'results.age.22h': '22 horas',
    'results.age.1d': '1 día',
    'results.age.7d': '7 días',
    'results.age.28d': '28 días',
    'results.ageShort.1h': '1 h',
    'results.ageShort.6h': '6 h',
    'results.ageShort.22h': '22 h',
    'results.ageShort.1d': '1 d',
    'results.ageShort.7d': '7 d',
    'results.ageShort.28d': '28 d',
    'results.status.pending': 'Pendiente',
    'results.status.ok': 'Leída',
    'results.status.unavailable': 'No disponible',
    'results.status.failed': 'Fallida',
    'results.status.expired': 'Perdida',
  },
  en: {
    'results.title': 'Results',
    'results.defaultRange': 'Last 90 days',
    'results.filters': 'Filters',
    'results.network': 'Network',
    'results.allNetworks': 'All networks',
    'results.from': 'From',
    'results.to': 'To',
    'results.clear': 'Clear',
    'results.note': 'Each network counts its own way, so networks are never added together: a “view” does not mean the same on each. Each network’s totals come from the latest reading of each post.',
    'results.empty': 'No results for these dates.',
    'results.emptyHint': 'Readings are taken 1 hour, 1 day, 7 days and 28 days after the app publishes a post (stories sooner, because their numbers disappear after a day). Posts published by hand have none.',

    'results.posts': { one: '{count} post', other: '{count} posts' },
    'results.read': { zero: 'none read yet', one: '{count} with a reading', other: '{count} with a reading' },
    'results.totals': '{network} totals',
    'results.col.post': 'Post',
    'results.col.reading': 'Reading',
    'results.col.after': 'After',
    'results.col.state': 'State',
    'results.metric.views': 'Views',
    'results.metric.reach': 'Reach',
    'results.metric.likes': 'Likes',
    'results.metric.comments': 'Comments',
    'results.metric.shares': 'Shares',
    'results.metric.saves': 'Saves',
    'results.metric.avgWatchSeconds': 'Avg watch',
    'results.metric.watchMinutes': 'Watch time (min)',
    'results.seconds': '{n} s',
    'results.after': 'After {age}',
    'results.notRead': 'Not read yet',
    'results.readings': 'Readings',
    'results.readingsOf': 'Readings of {title}',
    'results.readingTitle': '{age}: {status}',
    'results.private': 'Private: numbers are for a post only the account can see',
    'results.published': 'Published {date}',
    'results.openPost': 'Open post',
    'results.readAt': 'Read {date}',
    'results.dueAt': 'Due {date}',
    'results.detailNote': 'Each network counts its own way, and some numbers are not offered for some kinds of post. A dash means the network gave no number.',

    'results.age.1h': '1 hour',
    'results.age.6h': '6 hours',
    'results.age.22h': '22 hours',
    'results.age.1d': '1 day',
    'results.age.7d': '7 days',
    'results.age.28d': '28 days',
    'results.ageShort.1h': '1 h',
    'results.ageShort.6h': '6 h',
    'results.ageShort.22h': '22 h',
    'results.ageShort.1d': '1 d',
    'results.ageShort.7d': '7 d',
    'results.ageShort.28d': '28 d',
    'results.status.pending': 'Waiting',
    'results.status.ok': 'Read',
    'results.status.unavailable': 'Not available',
    'results.status.failed': 'Failed',
    'results.status.expired': 'Missed',
  },
});
